import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import styles from './ListaEquipes.module.css';
import PageHeader from '../../components/PageHeader/PageHeader';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';
import { FiUsers, FiTruck, FiCalendar, FiPlus, FiAlertCircle, FiChevronRight } from 'react-icons/fi';

const ListaEquipes = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [equipes, setEquipes] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchEquipes = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) throw new Error("Usuário não autenticado.");

        const [response] = await Promise.all([
            axios.get(`${API_BASE_URL}/api/colheita/equipes`, {
                headers: { Authorization: `Bearer ${token}` }
            }),
            new Promise(resolve => setTimeout(resolve, 800))
        ]);
        setEquipes(response.data);
      } catch (err) {
        console.error(err);
        setError("Erro ao carregar as equipes.");
      } finally {
        setLoading(false);
      }
    };

    fetchEquipes();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    // Garante que o formato é YYYY-MM-DD para evitar problemas de timezone
    const date = new Date(dateString);
    // Adiciona um pequeno ajuste para evitar problemas de fuso horário
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    return date.toLocaleDateString('pt-BR');
  };
  
  // Função NOVA: Navega para a tela de detalhes da equipe
  const handleDetailsClick = (id) => {
    navigate(`/lista-equipes/${id}`);
  };

  return (
    <div className={styles.container}>
      {loading && <LoadingOverlay text="Carregando equipes..." />}

      <PageHeader 
        title="Equipes de Produção" 
        subtitle="Visualize e gerencie suas equipes e maquinários vinculados."
        backTo="/sistema-colheita"
      />

      <div className={styles.content}>
        
        {!loading && equipes.length > 0 && (
            <div className={styles.actionRow}>
                <button className={styles.btnCreate} onClick={() => navigate('/cadastro-equipe-colheita')}>
                    <FiPlus size={20} /> Nova Equipe
                </button>
            </div>
        )}

        {error && (
            <div className={styles.errorMsg}>
                <FiAlertCircle size={24} />
                {error}
            </div>
        )}

        {!loading && !error && equipes.length === 0 && (
            <div className={styles.emptyState}>
                <FiUsers size={64} style={{ opacity: 0.2 }} />
                <h3>Nenhuma equipe ativa</h3>
                <p>Crie sua primeira equipe para começar a gerenciar as colheitas.</p>
                <button onClick={() => navigate('/colheita/nova-equipe')}>
                    <FiPlus /> Criar Equipe
                </button>
            </div>
        )}

        <div className={styles.grid}>
            {equipes.map(equipe => (
                <div 
                    key={equipe.id} 
                    className={styles.card}
                    // Torna o card inteiro clicável
                    onClick={() => handleDetailsClick(equipe.id)} 
                >
                    <div className={styles.cardHeader}>
                        <div className={styles.equipeInfo}>
                            <div className={styles.iconBox}>
                                <FiUsers />
                            </div>
                            <div className={styles.equipeName}>
                                <h3>{equipe.nome}</h3>
                                <span>ID: #{equipe.id.toString().padStart(4, '0')}</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className={styles.cardStats}>
                        <div className={styles.statItem}>
                            <span className={styles.statLabel}>
                                <FiTruck /> Maquinários
                            </span>
                            <span className={styles.statValue}>
                                {equipe.total_veiculos} Unidades
                            </span>
                        </div>
                        <div className={styles.statItem}>
                            <span className={styles.statLabel}>
                                <FiCalendar /> Criado em
                            </span>
                            <span className={styles.statValue}>
                                {formatDate(equipe.criado_em)}
                            </span>
                        </div>
                    </div>

                    <div className={styles.cardFooter}>
                        <span className={styles.statusBadge}>Operacional</span>
                        <button 
                            className={styles.btnDetails}
                            // Evita que o clique do botão acione o clique do card duas vezes
                            onClick={(e) => { 
                                e.stopPropagation(); 
                                handleDetailsClick(equipe.id);
                            }}
                        >
                            Ver detalhes <FiChevronRight style={{ marginBottom: -2 }} />
                        </button>
                    </div>
                </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ListaEquipes;